import * as styles from './styles.css';
import ComponentParser from '../component-parser';

export interface IViewProps {
  id?: string;
}

const View = ({ id }: IViewProps) => {
  return (
    <div id={id} className={styles.view}>
      <ComponentParser id={id} />
    </div>
  );
};

export default View;
